import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Feature Box',
  name: 'featureBox',
  type: 'object',
  fields: [
    defineField({
      title: 'Main Title',
      name: 'title',
      type: 'string',
      description: 'Same link will be used for the entire box',
    }),
    defineField({
      title: 'Show Vehicle Selector Modal on Click?',
      name: 'vehicleSelector',
      type: 'boolean',
      initialValue: false,
    }),
    defineField({
      title: 'Link',
      name: 'link',
      type: 'link',
      hidden: ({ parent }: { parent?: any }) => parent?.vehicleSelector,
    }),
    defineField({
      title: 'Background',
      name: 'bg',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
  ],
})